// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";

function PorterStoreButton(Props) {
  var label = Props.label;
  var onClick = Props.onClick;
  var disabledOpt = Props.disabled;
  var classNameOpt = Props.className;
  var disabled = disabledOpt !== undefined ? disabledOpt : false;
  var className = classNameOpt !== undefined ? classNameOpt : "ps-sidebar__payment-btn";
  return React.createElement("button", {
              className: disabled ? className + " " + className + "--disabled" : className,
              disabled: disabled,
              onClick: (function (param) {
                  return Curry._1(onClick, undefined);
                })
            }, label);
}

var make = PorterStoreButton;

export {
  make ,
  
}
/* react Not a pure module */
